import { Http } from '@/lib/utils/Http'
import JWTDecode from 'jwt-decode'
import Vue from 'vue'
export class Auth {
  public static readonly routesWithoutAuth = [
    'Login',
    'Forget',
    'Forget Password',
    'Reset Password',
    'ResetPassword',
    'Charity',
    'Vote',
    'Register',
    'TeamSite',
    'Donate'
  ]

  static async tryLogin (): Promise<boolean> {
    if (Auth.isTokenValid()) {
      return true
    }

    if (await Auth.refreshToken()) {
      return true
    }

    return false
  }

  static async refreshToken (): Promise<boolean> {
    if (window.localStorage.getItem('refreshToken')) {
      const tokenData = window.localStorage.getItem('refreshToken')
      if (!tokenData) {
        return false
      }
      const decodedToken = JWTDecode(tokenData) as any
      if (decodedToken) {
        if (decodedToken.exp - (Date.now() / 1000) > 0) {
          // refresh token still valid, try refresh access token
          const res = await Http.request('/api/auth/refresh', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ refreshToken: tokenData })
          }, false)
          if (res.status !== 200) {
            return false
          }
          const token = (await res.json()).accessToken
          window.localStorage.setItem('accessToken', token)
          // alert((Vue as any).cookie)
          return true
        }
      }
    }
    return false
  }

  static isTokenValid (): boolean {
    if (window.localStorage.getItem('accessToken')) {
      const tokenData = window.localStorage.getItem('accessToken')
      if (!tokenData) {
        return false
      }
      const decodedToken = JWTDecode(tokenData) as any
      if (decodedToken) {
        if (decodedToken.exp - (Date.now() / 1000) > 0) {
          // token still valid
          return true
        }
      }
    }
    return false
  }

  static getDecodedToken (): any {
    const token = window.localStorage.getItem('accessToken')
    if (!token) {
      return false
    }

    return JWTDecode(token)
  }
}
